import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useStudentCredentialParchmentInformations,
  useUpdate: useStudentCredentialParchmentInformationsUpdate,
} = getCRUDHooks({
  entityName: 'student-credential-parchment-informations',
});

export {
  useStudentCredentialParchmentInformations,
  useStudentCredentialParchmentInformationsUpdate,
};
